import script from "./RatingSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingSkills.vue?vue&type=script&setup=true&lang=js"

import "./RatingSkills.vue?vue&type=style&index=0&id=7ca02db4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca02db4"]])

export default __exports__